/* Galaxy predictive search (2026-08-03, code search 2026-10-05)
   The custom .galaxy-search form replaced Dawn's header search, and Dawn's
   <predictive-search> element went with it — so the bar had no type-ahead at all.
   This bolts a dropdown onto the existing form without touching header.liquid.

   Covers every resource suggest.json exposes: products, collections, pages,
   articles and query suggestions. Empty groups render nothing, so the blog group
   simply won't appear until there are posts.

   CODE SEARCH (2026-10-05)
   Shopify search only matches WHOLE words. "WK600*800mm" is indexed as the word
   "wk600", so typing "WK" or "KC" misses most of a series, and suggest.json also
   drops weak matches (WK came back with 3 of 21). That can't be configured away,
   so we keep our own small index and match on ANY fragment of title or SKU:
   • templates/collection.gps-index.liquid serves it (/collections/all?view=gps-index,
     250 products per page, ~32KB gzipped for the whole catalogue).
   • It is NOT loaded with the page. It is fetched the first time someone focuses a
     search box (or lands on /search), then kept in localStorage for an hour.
   • Code-like queries (contain a digit, or match the start of a code such as WK600)
     list every local match first, then whatever Shopify adds. Plain words
     ("pendant") keep Shopify's ranking; local matches only fill empty slots.
   • /search: products the index found but Shopify's results lack are appended to the
     grid using templates/product.gps-card.liquid, so the cards are the real theme
     cards. Skipped when filters or a non-default sort are active.
   • New products / price changes reach the index within the 1h cache window.

   Notes worth keeping:
   • resources[options][fields] MUST include variants.sku. Galaxy customers search by
     product code ("P105-SG", "S101-B", "A123"); without that field suggest.json only
     matches titles and those queries come back empty.
   • suggest.json returns product price as a plain decimal string ("398.00"), NOT cents.
     The local index stores cents; toRow() converts.
   • Collections/articles expose their image as either a bare URL string or an object
     with .url — imgOf() handles both; don't assume one shape.
   • resources[limit] is a single value for ALL types (max 10), so per-group caps are
     applied client-side in GROUPS below.
   • Shopify's OR search caps out around 9 terms, so expanding "WK" into
     "WK600 OR WK700 ..." on /search does NOT work. That's why we append cards instead.
   • The panel lives on <body>, position:fixed — see the CSS for why. */
(function () {
  if (window.__galaxyPS) return;
  window.__galaxyPS = 1;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CUR = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'NZD';
  var MIN = 2, DEBOUNCE = 180, FETCH_LIMIT = 6;
  var GROUPS = { products: 6, collections: 4, articles: 3, pages: 3, queries: 4 };
  var CODE_MAX = 40;           /* rows in the dropdown for a code query */
  var PAGE_ADD_MAX = 48;       /* extra cards appended on /search */
  var IDX_KEY = 'gpsIdx:v1', IDX_TTL = 3600e3;
  var cache = new Map();

  var ICON_SEARCH = '<svg viewBox="0 0 18 19" fill="none" aria-hidden="true"><path fill="currentColor" fill-rule="evenodd" d="M11.03 11.68A5.784 5.784 0 1 1 2.85 3.5a5.784 5.784 0 0 1 8.18 8.18m.26 1.12a6.78 6.78 0 1 1 .72-.7l5.4 5.4a.5.5 0 1 1-.71.7z" clip-rule="evenodd"/></svg>';
  var ICON_COLL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><rect x="3.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="3.5" y="13.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="13.5" width="7" height="7" rx="1.5"/></svg>';
  var ICON_DOC = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round" aria-hidden="true"><path d="M6 3h7l5 5v13H6z"/><path d="M13 3v5h5"/></svg>';
  var ICON_ART = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><rect x="3.5" y="4.5" width="17" height="15" rx="2"/><path d="M7 9h10M7 12.5h10M7 16h6"/></svg>';

  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    try {
      return new Intl.NumberFormat('en-NZ', { style: 'currency', currency: CUR, minimumFractionDigits: 2 }).format(n);
    } catch (e) { return '$' + n.toFixed(2); }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function mark(text, q) {
    var t = esc(text), needle = q.trim().split(/\s+/)[0] || '';
    if (!needle) return t;
    var i = t.toLowerCase().indexOf(needle.toLowerCase());
    if (i < 0) return t;
    return t.slice(0, i) + '<mark>' + t.slice(i, i + needle.length) + '</mark>' + t.slice(i + needle.length);
  }
  /* image can be a URL string OR an object with .url, depending on resource type */
  function imgOf(o) {
    var u = (o && o.featured_image && o.featured_image.url) || (o && o.image && o.image.url) || (o && typeof o.image === 'string' ? o.image : '');
    if (!u) return '';
    if (/[?&]width=/.test(u)) return u;                 /* index URLs are already sized */
    return u.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2');
  }
  function strip(html, n) {
    var d = document.createElement('div');
    d.innerHTML = html || '';
    var t = (d.textContent || '').replace(/\s+/g, ' ').trim();
    return t.length > n ? t.slice(0, n - 1) + '…' : t;
  }

  /* ---------------- local index ---------------- */
  var idxRows = null, idxPromise = null;
  function lsGet() { try { var o = JSON.parse(localStorage.getItem(IDX_KEY) || 'null'); return o && Date.now() - o.t < IDX_TTL ? o.d : null; } catch (e) { return null; } }
  function lsSet(d) { try { localStorage.setItem(IDX_KEY, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {} }
  function getPage(n) {
    return fetch(ROOT + 'collections/all?view=gps-index&page=' + n, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('idx ' + r.status); return r.text(); })
      .then(function (t) { return JSON.parse(t); });
  }
  /* Chunks are split on spaces only, punctuation removed inside each chunk, so
     "WK600*800mm" -> "wk600800mm" and "FB-KC600-800" -> "fbkc600800". Matching never
     joins two separate words ("black cob" must not match "kc"). */
  function chunks(s) {
    return String(s || '').toLowerCase().split(/\s+/).map(function (c) { return c.replace(/[^a-z0-9]+/g, ''); }).filter(Boolean);
  }
  function prep(raw) {
    return raw.map(function (r) {
      return {
        title: r[0], handle: r[1], type: r[2], price: r[4], cmp: r[5], available: r[6], img: r[7],
        tch: chunks(r[0]), sch: chunks(r[3]),
        toks: String(r[0] || '').toLowerCase().split(/[^a-z0-9]+/).filter(Boolean),
        stoks: String(r[3] || '').toLowerCase().split(/[^a-z0-9]+/).filter(Boolean)
      };
    });
  }
  function inChunks(arr, w) { for (var i = 0; i < arr.length; i++) if (arr[i].indexOf(w) >= 0) return true; return false; }
  /* A query word must sit inside one token ("kc" in "kc600", never across the dash in
     "Black-CCT"). Only words with a digit may span punctuation ("600800" in "600*800mm"). */
  function wordHit(p, w) {
    if (inChunks(p.toks, w) || inChunks(p.stoks, w)) return true;
    return /\d/.test(w) && (inChunks(p.tch, w) || inChunks(p.sch, w));
  }
  function loadIndex() {
    if (idxRows) return Promise.resolve(idxRows);
    if (idxPromise) return idxPromise;
    var cached = lsGet();
    if (cached) { idxRows = prep(cached); return Promise.resolve(idxRows); }
    idxPromise = getPage(1).then(function (first) {
      var rest = [];
      for (var i = 2; i <= Math.min(first.pages || 1, 12); i++) rest.push(getPage(i));
      return Promise.all(rest).then(function (more) {
        var raw = first.p.slice();
        more.forEach(function (m) { raw = raw.concat(m.p || []); });
        lsSet(raw);
        idxRows = prep(raw);
        return idxRows;
      });
    }).catch(function () { idxPromise = null; return null; });
    return idxPromise;
  }

  /* Every query word must appear inside one word of the title or SKU (punctuation
     ignored, so "600*800" hits "WK600*800mm"). Scores:
     3 = a title word STARTS with the first query word (WK -> WK600)
     2 = found inside the title   1 = SKU only */
  function localSearch(q) {
    if (!idxRows) return null;
    var words = q.toLowerCase().split(/\s+/).map(function (w) { return w.replace(/[^a-z0-9]+/g, ''); }).filter(Boolean);
    if (!words.length) return [];
    var w0 = words[0], out = [];
    for (var i = 0; i < idxRows.length; i++) {
      var p = idxRows[i], ok = true;
      for (var j = 0; j < words.length; j++) if (!wordHit(p, words[j])) { ok = false; break; }
      if (!ok) continue;
      var s = 1, codeHit = false, key = '';
      for (var k = 0; k < p.toks.length; k++) {
        if (p.toks[k].indexOf(w0) === 0) { s = 3; key = p.toks[k]; if (/\d/.test(key)) codeHit = true; break; }
      }
      if (s < 3) {
        if (inChunks(p.toks, w0) || (/\d/.test(w0) && inChunks(p.tch, w0))) s = 2;
        for (var m = 0; m < p.stoks.length; m++) if (p.stoks[m].indexOf(w0) === 0 && /\d/.test(p.stoks[m])) { codeHit = true; break; }
      }
      out.push({ p: p, s: s, code: codeHit, key: key });
    }
    out.sort(function (a, b) {
      return (b.s - a.s)
        || (a.key && b.key ? a.key.localeCompare(b.key, 'en', { numeric: true }) : 0)
        || ((b.p.available ? 1 : 0) - (a.p.available ? 1 : 0))
        || String(a.p.title).localeCompare(String(b.p.title), 'en', { numeric: true, sensitivity: 'base' });
    });
    return out;
  }
  /* Code-like = has a digit, or the first word starts a code (WK -> WK600). */
  function isCodeQuery(q, hits) {
    if (/\d/.test(q)) return !!(hits && hits.length);
    if (/\s/.test(q.trim())) return false;
    return !!(hits && hits.some(function (h) { return h.code; }));
  }
  function toRow(p) {
    return {
      title: p.title, url: ROOT + 'products/' + p.handle, type: p.type, available: p.available,
      price_min: (p.price || 0) / 100, compare_at_price_min: (p.cmp || 0) / 100, image: p.img, handle: p.handle
    };
  }
  function handleOf(url) { var m = String(url || '').match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }

  window.GalaxySearchIndex = { load: loadIndex, search: localSearch };

  /* ---------------- dropdown ---------------- */
  function build(form) {
    var input = form.querySelector('input[name="q"]');
    if (!input) return;

    var panel = document.createElement('div');
    panel.className = 'gps-panel';
    panel.id = 'gps-panel-' + Math.random().toString(36).slice(2, 8);
    panel.setAttribute('role', 'listbox');
    var scroll = document.createElement('div');
    scroll.className = 'gps-scroll';
    panel.appendChild(scroll);
    var foot = document.createElement('a');
    foot.className = 'gps-all';
    foot.setAttribute('role', 'option');
    panel.appendChild(foot);
    document.body.appendChild(panel);

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', panel.id);
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('spellcheck', 'false');

    var timer = null, ctrl = null, items = [], idx = -1, open = false;

    function place() {
      var r = form.getBoundingClientRect();
      panel.style.left = r.left + 'px';
      panel.style.width = r.width + 'px';
      panel.style.top = (r.bottom + 8) + 'px';
    }
    function show() {
      place();
      if (open) return;
      open = true;
      panel.setAttribute('data-open', '1');
      input.setAttribute('aria-expanded', 'true');
      window.addEventListener('scroll', place, true);
      window.addEventListener('resize', place);
    }
    function hide() {
      if (!open) return;
      open = false; idx = -1;
      panel.removeAttribute('data-open');
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      window.removeEventListener('scroll', place, true);
      window.removeEventListener('resize', place);
    }
    function highlight(n) {
      if (!items.length) return;
      if (idx >= 0 && items[idx]) items[idx].removeAttribute('data-active');
      idx = (n + items.length) % items.length;
      var el = items[idx];
      el.setAttribute('data-active', '1');
      input.setAttribute('aria-activedescendant', el.id);
      if (el.parentNode === scroll || scroll.contains(el)) {
        var pt = el.offsetTop, ph = el.offsetHeight, st = scroll.scrollTop, sh = scroll.clientHeight;
        if (pt < st) scroll.scrollTop = pt;
        else if (pt + ph > st + sh) scroll.scrollTop = pt + ph - sh;
      }
    }

    function rowProduct(p, q) {
      var img = imgOf(p);
      var price = p.available
        ? (parseFloat(p.compare_at_price_min) > parseFloat(p.price_min)
            ? '<s>' + money(p.compare_at_price_min) + '</s>' + money(p.price_min)
            : money(p.price_min || p.price))
        : '<span class="gps-sold">Sold out</span>';
      return '<a class="gps-row" role="option" href="' + esc(p.url) + '">'
        + (img ? '<img class="gps-thumb" src="' + esc(img) + '" alt="" loading="lazy" width="44" height="44">'
               : '<span class="gps-thumb gps-ic">' + ICON_DOC + '</span>')
        + '<span class="gps-tt"><b>' + mark(p.title, q) + '</b>'
        + (p.type ? '<span>' + esc(p.type) + '</span>' : '') + '</span>'
        + '<span class="gps-price">' + price + '</span></a>';
    }
    function rowSimple(o, q, icon, sub) {
      var img = imgOf(o);
      return '<a class="gps-row" role="option" href="' + esc(o.url) + '">'
        + (img ? '<img class="gps-thumb" src="' + esc(img) + '" alt="" loading="lazy" width="44" height="44">'
               : '<span class="gps-thumb gps-ic">' + icon + '</span>')
        + '<span class="gps-tt"><b>' + mark(o.title, q) + '</b>'
        + (sub ? '<span>' + esc(sub) + '</span>' : '') + '</span></a>';
    }

    /* Merge Shopify's products with the local index (see header comment). */
    function mergeProducts(q, shopify) {
      var hits = localSearch(q);
      if (!hits || !hits.length) return { list: shopify.slice(0, GROUPS.products), total: 0 };
      var seen = {}, list = [];
      function add(p) { var h = p.handle || handleOf(p.url); if (h && seen[h]) return; if (h) seen[h] = 1; list.push(p); }
      if (isCodeQuery(q, hits)) {
        hits.forEach(function (h) { add(toRow(h.p)); });
        shopify.forEach(add);
        return { list: list.slice(0, CODE_MAX), total: list.length };
      }
      shopify.forEach(add);
      for (var i = 0; i < hits.length && list.length < GROUPS.products; i++) add(toRow(hits[i].p));
      return { list: list.slice(0, GROUPS.products), total: 0 };
    }

    function render(q, data) {
      var res = (data && data.resources && data.resources.results) || {};
      var merged = mergeProducts(q, res.products || []);
      var products = merged.list;
      var colls = (res.collections || []).slice(0, GROUPS.collections);
      var arts = (res.articles || []).slice(0, GROUPS.articles);
      var pages = (res.pages || []).slice(0, GROUPS.pages);
      var queries = (res.queries || []).slice(0, GROUPS.queries);
      var html = '';

      if (products.length) {
        html += '<div class="gps-head">Products' + (merged.total > GROUPS.products ? ' · ' + merged.total : '') + '</div>';
        products.forEach(function (p) { html += rowProduct(p, q); });
      }
      if (colls.length) {
        html += '<div class="gps-head">Collections</div>';
        colls.forEach(function (c) { html += rowSimple(c, q, ICON_COLL, 'Collection'); });
      }
      if (arts.length) {
        html += '<div class="gps-head">Guides &amp; articles</div>';
        arts.forEach(function (a) { html += rowSimple(a, q, ICON_ART, strip(a.summary_html || a.body, 60)); });
      }
      if (pages.length) {
        html += '<div class="gps-head">Pages</div>';
        pages.forEach(function (p) { html += rowSimple(p, q, ICON_DOC, strip(p.body, 60)); });
      }
      if (queries.length) {
        html += '<div class="gps-head">Suggestions</div>';
        queries.forEach(function (t) {
          html += '<a class="gps-term" role="option" href="' + ROOT + 'search?q=' + encodeURIComponent(t.text) + '">'
            + ICON_SEARCH + mark(t.text, q) + '</a>';
        });
      }
      if (!html) {
        html = '<div class="gps-empty">No matches for “' + esc(q) + '”. Try a product code, a category, or a room.</div>';
      }

      scroll.innerHTML = html;
      scroll.scrollTop = 0;
      foot.href = ROOT + 'search?q=' + encodeURIComponent(q);
      foot.textContent = 'See all results for “' + q + '” →';

      items = Array.prototype.slice.call(panel.querySelectorAll('[role="option"]'));
      items.forEach(function (el, i) { el.id = panel.id + '-o' + i; });
      idx = -1;
      show();
    }

    function run(q) {
      if (cache.has(q)) { render(q, cache.get(q)); return; }
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(q)
        + '&resources[type]=product,collection,page,article,query'
        + '&resources[limit]=' + FETCH_LIMIT
        + '&resources[options][unavailable_products]=last'
        + '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor';
      var sug = fetch(url, { signal: ctrl.signal }).then(function (r) { return r.json(); });
      /* Wait for the index too (instant once cached); never let it block suggestions. */
      Promise.all([sug, loadIndex().catch(function () { return null; })])
        .then(function (r) { cache.set(q, r[0]); if (input.value.trim() === q) render(q, r[0]); })
        .catch(function (e) {
          if (e.name === 'AbortError') return;
          if (idxRows && input.value.trim() === q) render(q, {}); else hide();
        });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < MIN) { hide(); return; }
      timer = setTimeout(function () { run(q); }, DEBOUNCE);
    });
    input.addEventListener('focus', function () {
      loadIndex();
      if (input.value.trim().length >= MIN && scroll.innerHTML) show();
    });
    input.addEventListener('keydown', function (e) {
      if (!open) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); highlight(idx + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(idx - 1); }
      else if (e.key === 'Enter') { if (idx >= 0 && items[idx]) { e.preventDefault(); items[idx].click(); } }
      else if (e.key === 'Escape') { hide(); input.blur(); }
    });
    document.addEventListener('click', function (e) {
      if (!panel.contains(e.target) && !form.contains(e.target)) hide();
    });
    form.addEventListener('submit', hide);
  }

  /* ---------------- /search results page ---------------- */
  function augmentSearchPage() {
    var root = document.querySelector('.template-search');
    if (!root) return;
    var params = new URLSearchParams(window.location.search);
    var q = (params.get('q') || '').trim();
    if (q.length < MIN) return;
    var page = parseInt(params.get('page') || '1', 10);
    var filtered = false;
    params.forEach(function (v, k) { if (k.indexOf('filter.') === 0) filtered = true; });
    if (filtered || (params.get('sort_by') && params.get('sort_by') !== 'relevance') || page > 1) return;

    loadIndex().then(function () {
      var hits = localSearch(q);
      if (!hits || !hits.length || !isCodeQuery(q, hits)) return;

      /* Handles Shopify already shows, across all its result pages. */
      var shown = {};
      function collect(scope) {
        scope.querySelectorAll('#product-grid a[href*="/products/"]').forEach(function (a) { var h = handleOf(a.getAttribute('href')); if (h) shown[h] = 1; });
      }
      collect(document);
      var pag = root.querySelector('.pagination');
      var lastPage = 1;
      if (pag) pag.querySelectorAll('a[href*="page="]').forEach(function (a) {
        var n = parseInt((a.getAttribute('href').match(/page=(\d+)/) || [])[1], 10); if (n > lastPage) lastPage = n;
      });
      var more = [];
      for (var n = 2; n <= Math.min(lastPage, 6); n++) {
        var u = new URL(window.location.href); u.searchParams.set('page', n);
        more.push(fetch(u.toString()).then(function (r) { return r.text(); }).then(function (t) {
          collect(new DOMParser().parseFromString(t, 'text/html'));
        }).catch(function () {}));
      }
      return Promise.all(more).then(function () {
        var missing = hits.filter(function (h) { return !shown[h.p.handle]; }).slice(0, PAGE_ADD_MAX);
        if (!missing.length) return;
        return Promise.all(missing.map(function (h) {
          return fetch(ROOT + 'products/' + encodeURIComponent(h.p.handle) + '?view=gps-card')
            .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
        })).then(function (cards) {
          var html = cards.join('');
          if (html.indexOf('grid__item') < 0) return;
          var ul = root.querySelector('#product-grid ul.product-grid');
          if (!ul) {
            /* Shopify found nothing: build the grid the section would have rendered. */
            var grid = root.querySelector('#product-grid');
            if (!grid) {
              grid = document.createElement('div');
              grid.id = 'product-grid';
              grid.className = 'template-search__results collection page-width';
              root.appendChild(grid);
            }
            grid.classList.remove('collection--empty');
            grid.innerHTML = '<ul class="grid product-grid grid--2-col-tablet-down grid--4-col-desktop" role="list"></ul>';
            ul = grid.querySelector('ul');
          }
          /* Extra cards go after Shopify's page-1 results; its pagination (if any) stays. */
          if (pag) ul.parentNode.insertBefore(pag, null);
          ul.insertAdjacentHTML('beforeend', html);
          root.classList.remove('template-search--empty');
          var empty = root.querySelector('.gsp-empty'); if (empty) empty.remove();
          var total = Object.keys(shown).length + ul.querySelectorAll('[data-gps-added]').length;
          ['ProductCountDesktop', 'ProductCount'].forEach(function (id) {
            var el = document.getElementById(id); if (el) el.textContent = total + (total === 1 ? ' result' : ' results');
          });
        });
      });
    }).catch(function () {});
  }

  function init() {
    document.querySelectorAll('form.galaxy-search').forEach(build);
    augmentSearchPage();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
